define(function (require) {
    "use strict";

    var LE = require("app");
    var Template = require("personalization-user-management-templates/lpaEdit.tmpl");
    var Button = require("ui/button/Button");
    var Multiselect = require("ui/multiselect/Multiselect");
    var toggleButton = require("ui/toggle-button/toggleButton");
    var positionsUtility = require("personalization-utils/positionsUtility");
    var ProfileModel = require("models/entities/ProfileModel");
    var List = require("ui/list/List");
    var TagsContainer = require("ui/tags-container/TagsContainer");
    var KpContent = require("ui.components/kpContent/kpContent");

    var LpaEditView = {};
    function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {
        LpaEditView = Marionette.ItemView.extend({
            template: Template,
            className: "lpa-edit-container anchor hide",
            ui: {
                cancelButton: ".cancel-edit",
                saveButton: ".save-edit",
                editContainer: ".edit-container",
                descriptionLabel: ".sub-title",
                lpaToggleButton: ".lpa-state-container .lpa-state-value",
                lpaAssignContainer: ".lpa-assign-container",
                knowledgePack: ".kp"
            },
            uiComponents: {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_cancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_save"
                    }
                },
                lpaEnabled: {
                    type: toggleButton,
                    options: {
                        transition: toggleButton.TRANSITION.FAST,
                        container:"view.ui.lpaToggleButton",
                        permutation: toggleButton.PERMUTATION.NIGHT_THEME
                    },
                    events:{
                        "toggleButton:change":"_onLpaEnabledChange"
                    }
                },
                profiles: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.lpaAssignContainer",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        trim: true,
                        items: "view._getProfilesArray",
                        list: {
                            groupsOrder: "view._getRolesGroupOrder",
                            singleSelectPerGroup: true,
                            theme: List.THEME.NIGHT
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEPersonalization.userManagement.lpa.assign.placeholder"),
                            theme: TagsContainer.THEME.NIGHT,
                            tagMaxWidth: "275px"
                        }
                    },
                    events: {
                        "select": "_onProfileSelect",
                        "unselect": "_onProfileUnSelect"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.knowledgePack",
                        contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
                        KPLink: LE.translator.translate("LEPersonalization.userManagement.lpa.title.learnMore"),
                        kpID: "lpa-permissions-assignment"
                    }
                }
            },
            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "LpaEditView:initialize", options);
                this.anchorSelector = options.anchorSelector;
                this.profilesCollection = options.profilesCollection || {};
                this.IsLpaAssignedInitialValue = options.IsLpaAssigned;
                this.IsLpaAssigned = options.IsLpaAssigned;
                this.assignedProfiles = [];
            },
            onRender: function () {
                LEPersonalization.logger.info("rendering", "LpaEditView:onRender");

                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.LEFT, positionsUtility.POSITION_Y.TOP);
                if (offset) {
                    this.$el.css(offset);
                }
                this.uiComponents.lpaEnabled.setChecked(this.IsLpaAssigned);
                this.ui.lpaAssignContainer.toggleClass("show", this.IsLpaAssigned);
                this.assignedProfiles = this.uiComponents.profiles.getSelectedItems();
                this._toggleSaveButtonState();
                this.$el.removeClass("hide");
            },
            _onLpaEnabledChange: function(componentId, eventName, checked){
                this.ui.lpaAssignContainer.toggleClass("show", checked);
                this.IsLpaAssigned = checked;
                this._toggleSaveButtonState();
                this.trigger("lpa:enable:change", {enabled:checked});
            },
            onClose: function () {
                LEPersonalization.logger.debug("closing view", "LpaEditView:onClose");
            },
            _cancel: function () {
                LEPersonalization.logger.debug("cancel button was pressed", "LpaEditView:_cancel");
                LEPersonalization.navigateToPageMenu();
            },
            _save: function () {
                LEPersonalization.logger.debug("saving LPA assignment", "LpaEditView:_save");
                //if assigned profiles but toggle set to false then save with empty ids (perform a delete)
                var assignedProfiles = (this.IsLpaAssignedInitialValue && !this.IsLpaAssigned) ? [] : this.assignedProfiles;
                this.trigger("lpa:save", {assignedProfiles: assignedProfiles});
            },
            _getRolesGroupOrder: function(){
                var rolesGroupOrder = LE.crossModule("userManagement", LE.media.actions.request, LE.mediaCodes.userManagement.reqres.profilesRolesGroup);
                return rolesGroupOrder;
            },
            _getProfilesArray: function() {
                var profilesArr = [];
                this.profilesCollection.each(function(profileModel) {
                    var roleTypeId = profileModel.getRoleTypeId().toString();
                    var selected = profileModel.getIsAssignedToLPA();

                    var role = LE.translator.translate(ProfileModel.ROLES_BY_IDS[roleTypeId]);
                    var tooltip = LE.translator.translate({
                        key: "LEUserManagement.userEdit.profiles.role.tooltip",
                        args: [{key: role, isTranslate: false}]
                    });

                    profilesArr.push({
                        id: profileModel.id,
                        value: profileModel.getName(),
                        group: role,
                        tooltip: tooltip,
                        selected: selected,
                        enabled: true
                    });
                }, this);

                return profilesArr;
            },
            _onProfileChange: function() {
                var profiles = this.uiComponents.profiles.getSelectedItems();
                this.assignedProfiles = profiles || [];
                this._toggleSaveButtonState();
            },

            _onProfileSelect: function(componentId, eventName, item) {
                this._onProfileChange();
            },

            _onProfileUnSelect: function(componentId, eventName, item) {
                this._onProfileChange();
            },
            _isSaveAllowed: function(){
                /*
                 save is allowed if profile has been assigned or if profile have been reset (toggle off with previous existing values)
                 */
                var saveAllowed = (this.IsLpaAssigned && this.assignedProfiles.length > 0) || (!this.IsLpaAssigned && this.IsLpaAssignedInitialValue);
                return saveAllowed;
            },
            _getSaveButtonState: function () {
                return this._isSaveAllowed() ? Button.STATES.ENABLED : Button.STATES.DISABLED;
            },
            _getSaveButtonTooltip: function () {
                return this._isSaveAllowed() ? null : LE.translator.translate("LEPersonalization.userManagement.lpa.save.tooltip");
            },

            _toggleSaveButtonState: function () {
                this.uiComponents.saveButton.setState(this._getSaveButtonState());
                this.uiComponents.saveButton.setTooltip(this._getSaveButtonTooltip());
            }
        });
    }

    LE.module("LEPersonalization", moduleDefinition);

    return LpaEditView;
});
